import React from 'react';
import SubmitButton from './../../components/SubmitButton/index';
import {InfoMessage} from '../../components/Messages/index';

const PickupForm = ({ onSubmit, inactive, email = '', submitTitle, warningMessage, disableMessage, attendeeEmail, handleFormSubmited, handleSameEmail, isWaitingList, sellerEmail=''}) => {
    const handleSubmit = () => {
        if (attendeeEmail !== undefined && attendeeEmail !== null && attendeeEmail !== "") {
            if (validateEmail(attendeeEmail)) {
                if (attendeeEmail == sellerEmail) {
                    handleSameEmail(true)
                }
                else {
                    onSubmit({ email });
                    handleSameEmail(false)
                    handleFormSubmited(false)
                }
            }
            else {
                handleSameEmail(false)
                handleFormSubmited(true)
            }
        }
        
    };

    const validateEmail = (email) => {
        const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return pattern.test(email);

    }

    const getDisableError = () => {
    let disableError = '';

        if (inactive) {
            
                disableError = 'Please select your available hours';
           
        }
       
    return disableError;
    }
  return (
    <div className='pickup-form'>
          <div className='form-controls'>
          {warningMessage && <InfoMessage logger title={warningMessage} />}
              {
              //    <SubmitButton
              //    disableError={getDisableError() || warningMessage}
              //    title={submitTitle || 'Confirm Attendance'}
              //    onClick={handleSubmit}
              ///>
                  <div className={(isWaitingList === true ? "join-list" : "")}>
                  <SubmitButton 
                      disableError={disableMessage  || warningMessage  }
                      title={submitTitle || (isWaitingList === true ? "JOIN WAITLIST" : "Confirm Attendance")}
                      onClick={handleSubmit}
                  />
                      </div>
              }
        </div>
    </div>
  );
}

export default PickupForm;